export default [
    {
        id: 1,
        name_ca: 'Zona A',
        name_en: 'Zone A',
        name_es: 'Zona A'
    },
    {
        id: 1,
        name_ca: 'Zona B',
        name_en: 'Zone B',
        name_es: 'Zona B'
    },
    {
        id: 1,
        name_ca: 'Zona C',
        name_en: 'Zone C',
        name_es: 'Zona C'
    },
    {
        id: 1,
        name_ca: 'Zona D',
        name_en: 'Zone D',
        name_es: 'Zona D'
    }
]



// WEBPACK FOOTER //
// ./src/options/protection_zones.js